'use strict'

var Simbix = function (config) {
  config = config || {}

  this.host = config.host
  this.port = config.port || 80
  this.username = config.username || null
  this.password = config.password || null
  this.sid = config.sid || null
}

// Connect
Simbix.prototype.connect = function () {
  var params = {
    login: this.username,
    password: this.password
  }

  var json = JSON.stringify({ params: params })
  var url = this.host + ':' + this.port + '/web/session/authenticate'

  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Length': json.length,
      'Cookie': ';'
    },
    credentials: 'include',
    mode: 'cors',
    body: json
  }

  
  var context = this
  //Для разработки, до реализации авторизации
  return Promise.resolve({ success: true, data: {user: "this.username"} })
  
  
  return fetch(url, options)
    .then(function (response) {
      if (response.headers.has['Set-Cookie']) {
          context.sid = response.headers.map['Set-Cookie'][0].split(';')[0];
      }
      return response.json()
    })
    .then(function (responseJson) {
      if (responseJson.error) return { success: false, error: responseJson.error }
      else {
        context.uid = responseJson.result.uid
        context.session_id = responseJson.result.session_id
        context.context = responseJson.result.user_context
        context.username = responseJson.result.username
        return { success: true, data: responseJson.result }
      }
    })
    .catch(function (error) {
      return { success: false, error: error }
    })
}

Simbix.prototype.getNodes = function (host, params) {
  this.host = host
  return this._request('/jsonrpc/endpoint', params.method, params)
}
// Read assets
Simbix.prototype.getAllAssets = function () {
  return this._request('/service', {
    method: 'getAssets',
    ids: []
  })
}

// Read 
Simbix.prototype.getClassificationScheme = function () {
  return this._request('/service', {
    method: 'getClassifiers',
    ids: []
  })
}

// Read record
Simbix.prototype.getAsset = function (id) {
  return this._request('/service', {
    method: 'getAssetCard',
    id: id,
	  accept: 'application/json'
  })
}

// Generic RPC wrapper
Simbix.prototype.rpc_call = function (endpoint, params) {
  return this._request(endpoint, params)
}

// Private functions
Simbix.prototype._request = function (path, method, params) {
  params = params || {}

  var url = this.host + ':' + this.port + (path || '/')
  var options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cookie': this.sid + ';',
      'Authorization': 'Basic bG9naW46cGFzc3dvcmQ='
    },
    credentials: 'include',
    mode: 'cors',
    body: JSON.stringify({
      jsonrpc: '2.0',
      id: new Date().getUTCMilliseconds(),
      method: method,
      params: params
    })
  }
  console.log("Simbix.prototype._request", url, options);
  return fetch(url, options)
    .then(function (response) {
		//console.log("fetch(url, options)", url, options, response)
      return response.json()
    })
    .then(function (responseJson) {
      if (responseJson.error) return { success: false, error: responseJson.error }
      else return { success: true, data: responseJson }
    })
    .catch(function (error) {
      return { success: false, error: error }
    })
}

module.exports = Simbix
